<template>
  <div class="big-title-box">
    <div class="left">
      <div class="line"></div>
      <p class="title">{{ title }}</p>
    </div>
    <p class="more">更多>></p>
  </div>
</template>

<script>
export default {
  name: 'BigTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.big-title-box {
  // height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #0060B5;
  .left{
    display: flex;
    align-items: center;
    .line{
      width: 16px;
      height: 40px;
      background: #008BF2;
      margin-right: 20px;
    }
    .title {
      // padding: 9px 28px;
      color: #0060B5;
      display: inline-block;
      font: 500 20px/22px PingFangSC;
      font-weight: bold;
    }
  }
  .more {
    font-size: 18px;
    color: #008BF2;
    margin-right: 14px;
  }
}
.more:hover {
  color: #FF7801;
}
</style>
